module.exports = __webpack_public_path__ + "img/hero-1-img.bc225f95.png";